import React from 'react';

export const Polygon = ({
  className,
  color,
  height,
  width,
}: {
  className?: string;
  color?: string;
  height?: string;
  width?: string;
}) => (
  <svg
    width={width || '20'}
    height={height || '20'}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M4.60184 4.0189C4.71268 3.82258 4.92065 3.70117 5.14609 3.70117H14.8084C15.0322 3.70117 15.239 3.82089 15.3504 4.01504L18.1176 8.83588C18.2286 9.02929 18.2281 9.2672 18.1164 9.46019C18.0046 9.65318 17.7985 9.77201 17.5755 9.77201H2.42432C2.2021 9.77201 1.99659 9.65402 1.88456 9.46211C1.77253 9.2702 1.77082 9.03324 1.88007 8.83974L4.60184 4.0189ZM5.51096 4.95117L3.49491 8.52201H16.4961L14.4465 4.95117H5.51096Z"
      fill={color || '#B56705'}
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M10.442 17.1646C10.1979 17.4087 9.8022 17.4087 9.55812 17.1646L1.98252 9.58899C1.80377 9.41024 1.75029 9.14142 1.84703 8.90787C1.94377 8.67433 2.17167 8.52205 2.42446 8.52205L17.5757 8.52205C17.8285 8.52205 18.0564 8.67433 18.1531 8.90788C18.2498 9.14142 18.1964 9.41025 18.0176 9.58899L10.442 17.1646ZM16.0668 9.77205L3.93334 9.77205L10.0001 15.8388L16.0668 9.77205Z"
      fill={color || '#B56705'}
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M9.9999 17.3477C9.75481 17.3477 9.53234 17.2044 9.43092 16.9813L5.98747 9.40568C5.89953 9.21223 5.91592 8.98735 6.03096 8.80869C6.14601 8.63002 6.34395 8.52205 6.55645 8.52205L13.4434 8.52205C13.6559 8.52205 13.8538 8.63002 13.9688 8.80869C14.0839 8.98735 14.1003 9.21223 14.0123 9.40568L10.5689 16.9813C10.4675 17.2044 10.245 17.3477 9.9999 17.3477ZM12.4727 9.77205L7.52707 9.77205L9.9999 15.2123L12.4727 9.77205Z"
      fill={color || '#B56705'}
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M9.9999 3.70117C9.79806 3.70117 9.60864 3.79865 9.49132 3.9629L6.04786 8.78374C5.91178 8.97425 5.89359 9.22483 6.00071 9.433C6.10784 9.64117 6.32233 9.77201 6.55644 9.77201L13.4434 9.77201C13.6775 9.77201 13.892 9.64117 13.9991 9.433C14.1062 9.22483 14.088 8.97425 13.9519 8.78374L10.5085 3.9629C10.3912 3.79865 10.2017 3.70117 9.9999 3.70117ZM12.2289 8.52201L7.77094 8.52201L9.9999 5.40146L12.2289 8.52201Z"
      fill={color || '#B56705'}
    />
  </svg>
);
